(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-subscription-buy-box]';
  var INITIALIZED_ATTR = 'data-sbb-initialized';

  function initAllSubscriptionBuyBoxes(context) {
    var scope = context || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);

    sections.forEach(function (section) {
      initSubscriptionBuyBox(section);
    });
  }

  function initSubscriptionBuyBox(section) {
    if (!section || section.getAttribute(INITIALIZED_ATTR) === 'true') return;

    section.setAttribute(INITIALIZED_ATTR, 'true');

    initGallery(section);
    initFloatingButton(section);
    initForms(section);
  }

  function getConfig(section) {
    var configScript = section.querySelector('[data-sbb-config]');

    if (!configScript) {
      return {};
    }

    try {
      return JSON.parse(configScript.textContent || '{}');
    } catch (error) {
      console.error('[Subscription Buy Box] Invalid config JSON:', error);
      return {};
    }
  }

  function initGallery(section) {
    var gallery = section.querySelector('[data-sbb-gallery]');
    var track = section.querySelector('[data-sbb-gallery-track]');
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-sbb-slide]'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-sbb-thumb]'));

    if (!gallery || !track || slides.length === 0) return;

    var currentIndex = 0;
    var startX = 0;
    var isPointerDown = false;

    function showSlide(index) {
      if (slides.length === 0) return;

      currentIndex = normalizeIndex(index, slides.length);
      track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';

      thumbs.forEach(function (thumb, thumbIndex) {
        var isActive = thumbIndex === currentIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (thumbs[currentIndex]) {
        thumbs[currentIndex].scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-index'), 10);

        if (!Number.isNaN(index)) {
          showSlide(index);
        }
      });
    });

    gallery.addEventListener('pointerdown', function (event) {
      isPointerDown = true;
      startX = event.clientX;
    });

    gallery.addEventListener('pointerup', function (event) {
      if (!isPointerDown) return;

      var endX = event.clientX;
      var diff = startX - endX;

      isPointerDown = false;

      if (Math.abs(diff) < 40) return;

      if (diff > 0) {
        showSlide(currentIndex + 1);
      } else {
        showSlide(currentIndex - 1);
      }
    });

    gallery.addEventListener('pointerleave', function () {
      isPointerDown = false;
    });

    showSlide(0);
  }

  function normalizeIndex(index, total) {
    return (index + total) % total;
  }

  function initFloatingButton(section) {
    var floating = section.querySelector('[data-sbb-floating]');
    var primaryForm = section.querySelector('[data-sbb-form="primary"]');

    if (!floating || !primaryForm) return;

    if (!('IntersectionObserver' in window)) {
      floating.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      var primaryIsVisible = entries.some(function (entry) {
        return entry.isIntersecting;
      });

      floating.classList.toggle('is-visible', !primaryIsVisible);
    }, {
      threshold: 0
    });

    observer.observe(primaryForm);
  }

  function initForms(section) {
    var forms = Array.prototype.slice.call(section.querySelectorAll('[data-sbb-form]'));

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        handleSubmit(section, form);
      });
    });
  }

  function handleSubmit(section, form) {
    var config = getConfig(section);
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-sbb-button]'));
    var status = section.querySelector('[data-sbb-status]');
    var originalButtonLabels = buttons.map(function (button) {
      return button.innerHTML;
    });

    if (!config.variantId) {
      setStatus(status, 'Please select a product or enter a variant ID in the section settings.');
      return;
    }

    setLoading(buttons, config.loadingText || 'Adding...');

    addOfferToCart(config)
      .then(function () {
        return redirectAfterAdd(config);
      })
      .catch(function (error) {
        console.error('[Subscription Buy Box] Add to cart error:', error);
        setStatus(status, config.errorText || 'Something went wrong. Please try again.');
        resetButtons(buttons, originalButtonLabels);
      });
  }

  function addOfferToCart(config) {
    var sequence = Promise.resolve();

    if (config.clearCartBeforeAdd) {
      sequence = sequence.then(clearCart);
    }

    return sequence
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        var items = buildCartItems(config, cart);

        if (!items.length) {
          throw new Error('No valid cart items to add.');
        }

        return addItems(items);
      })
      .then(function () {
        return updateCartAttributes(config);
      });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to fetch cart.');
      }

      return response.json();
    });
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to clear cart.');
      }

      return response.json();
    });
  }

  function buildCartItems(config, cart) {
    var cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
    var items = [];

    var mainItem = normalizeCartItem({
      id: config.variantId,
      quantity: config.quantity || 1,
      sellingPlanId: config.sellingPlanId,
      dedupe: false
    });

    if (mainItem) {
      mainItem.properties = {
        _source: config.cartAttributeSource || 'subscription-buy-box'
      };

      items.push(mainItem);
    }

    var additionalItems = Array.isArray(config.additionalItems) ? config.additionalItems : [];

    additionalItems.forEach(function (additionalItem) {
      var normalizedItem = normalizeCartItem(additionalItem);

      if (!normalizedItem) return;

      if (additionalItem.dedupe && itemAlreadyInCart(cartItems, normalizedItem)) {
        return;
      }

      items.push(normalizedItem);
    });

    return items;
  }

  function normalizeCartItem(item) {
    if (!item || !item.id) return null;

    var normalized = {
      id: String(item.id),
      quantity: positiveInteger(item.quantity, 1)
    };

    if (item.sellingPlanId) {
      normalized.selling_plan = String(item.sellingPlanId);
    }

    return normalized;
  }

  function positiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);

    if (Number.isNaN(parsed) || parsed < 1) {
      return fallback;
    }

    return parsed;
  }

  function itemAlreadyInCart(cartItems, newItem) {
    return cartItems.some(function (cartItem) {
      var sameVariant = String(cartItem.variant_id) === String(newItem.id);
      var cartSellingPlanId = cartItem.selling_plan_allocation &&
        cartItem.selling_plan_allocation.selling_plan &&
        cartItem.selling_plan_allocation.selling_plan.id;

      var newSellingPlanId = newItem.selling_plan || '';
      var sameSellingPlan = String(cartSellingPlanId || '') === String(newSellingPlanId || '');

      return sameVariant && sameSellingPlan;
    });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (errorData) {
          throw new Error(errorData.description || errorData.message || 'Unable to add item to cart.');
        });
      }

      return response.json();
    });
  }

  function updateCartAttributes(config) {
    if (!config.cartAttributeSource) {
      return Promise.resolve();
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          subscription_buy_box_source: config.cartAttributeSource
        }
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to update cart attributes.');
      }

      return response.json();
    });
  }

  function redirectAfterAdd(config) {
    var redirectTarget = config.redirectTarget || 'checkout';

    if (redirectTarget === 'stay') {
      window.dispatchEvent(new CustomEvent('subscription-buy-box:added', {
        detail: {
          sectionId: config.sectionId
        }
      }));

      return Promise.resolve();
    }

    var targetPath = redirectTarget === 'cart' ? '/cart' : '/checkout';
    var discountCodes = parseDiscountCodes(config.discountCodes);
    var redirectUrl = buildRedirectUrl(targetPath, discountCodes);

    window.location.assign(redirectUrl);
    return Promise.resolve();
  }

  function parseDiscountCodes(rawCodes) {
    if (!rawCodes || typeof rawCodes !== 'string') {
      return [];
    }

    return rawCodes
      .split(',')
      .map(function (code) {
        return code.trim();
      })
      .filter(Boolean);
  }

  function buildRedirectUrl(redirectPath, discountCodes) {
    if (!Array.isArray(discountCodes) || discountCodes.length === 0) {
      return redirectPath;
    }

    var encodedCodes = discountCodes
      .map(function (code) {
        return encodeURIComponent(code);
      })
      .join(',');

    var separator = redirectPath.indexOf('?') === -1 ? '?' : '&';

    return redirectPath + separator + 'discount=' + encodedCodes;
  }

  function setLoading(buttons, loadingText) {
    buttons.forEach(function (button) {
      button.classList.add('is-loading');
      button.disabled = true;

      if (loadingText) {
        button.innerHTML = '<span class="subscription-buy-box__button-primary">' + escapeHtml(loadingText) + '</span>';
      }
    });
  }

  function resetButtons(buttons, originalButtonLabels) {
    buttons.forEach(function (button, index) {
      button.classList.remove('is-loading');
      button.disabled = false;

      if (originalButtonLabels[index]) {
        button.innerHTML = originalButtonLabels[index];
      }
    });
  }

  function setStatus(status, message) {
    if (!status) return;

    status.textContent = message || '';
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllSubscriptionBuyBoxes(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllSubscriptionBuyBoxes(event.target);
  });
})();